import React from 'react';
import PropTypes from 'prop-types';
import { Header } from 'semantic-ui-react';

// Filtro de ano pelo título, para listas de documentos (Lista DS). Não usa
// etiqueta nem data: o ano já está no título dos documentos ("Contrato nº
// 12/2026 – Empresa"), e o índice de título acha o ano dentro do número. Quem
// publica só sobe o PDF com o título no padrão de sempre.
//
// O ano em que a lista abre fica na consulta base do bloco ("título contém
// 2026"): o Volto inicia o filtro com esse valor, e o servidor e o navegador
// montam a mesma busca. Sem valor, o filtro é "Todos" e não põe critério. (Um
// "Todos" explícito não volta pela URL: o Volto refaz os filtros a partir dos
// critérios gravados, e "sem critério de título" chegaria como "sem valor".)
export const TODOS = 'todos';

const inteiro = (valor) => {
  const n = parseInt(valor, 10);
  return Number.isFinite(n) ? n : null;
};

export const anoMaisRecente = (facet, hoje = new Date()) =>
  inteiro(facet?.anoMaisRecente) ?? hoje.getFullYear();

export const anos = (facet, hoje = new Date()) => {
  const recente = anoMaisRecente(facet, hoje);
  const antigo = Math.min(inteiro(facet?.anoMaisAntigo) ?? recente, recente);
  const lista = [];
  for (let ano = recente; ano >= antigo; ano -= 1) lista.push(String(ano));
  return lista;
};

export const valorEfetivo = (value) =>
  value === undefined || value === null || value === '' ? TODOS : String(value);

const rotulo = (valor) => (valor === TODOS ? 'Todos' : valor);

const AnoTituloFacet = ({ facet, onChange, value, isEditMode }) => {
  const atual = valorEfetivo(value);
  const titulo = facet?.title || 'Ano';
  return (
    <div className="checkbox-facet ag-ano-facet">
      <Header as="h4">{titulo}</Header>
      <div className="entries" role="group" aria-label={titulo}>
        {[...anos(facet), TODOS].map((ano) => (
          <button
            key={ano}
            type="button"
            className={`ag-ano-facet__btn${atual === ano ? ' is-active' : ''}`}
            aria-pressed={atual === ano}
            disabled={isEditMode}
            onClick={() => onChange(facet.field.value, ano)}
          >
            {rotulo(ano)}
          </button>
        ))}
      </div>
    </div>
  );
};

AnoTituloFacet.propTypes = {
  facet: PropTypes.object.isRequired,
  onChange: PropTypes.func.isRequired,
  value: PropTypes.string,
  isEditMode: PropTypes.bool,
};

AnoTituloFacet.stateToValue = ({ selectedValue }) => selectedValue;

AnoTituloFacet.valueToQuery = ({ value, facet }) => {
  const ano = valorEfetivo(value);
  return ano === TODOS
    ? null
    : {
        i: facet.field.value,
        o: 'plone.app.querystring.operation.string.contains',
        v: ano,
      };
};

// O índice de título não tem lista de valores; sem isto o filtro sumiria
// fora da edição.
AnoTituloFacet.showFacet = () => true;

AnoTituloFacet.schemaEnhancer = ({ schema }) => {
  const [principal, ...demais] = schema.fieldsets;
  return {
    ...schema,
    fieldsets: [
      {
        ...principal,
        fields: [...principal.fields, 'anoMaisRecente', 'anoMaisAntigo'],
      },
      ...demais,
    ],
    properties: {
      ...schema.properties,
      anoMaisRecente: {
        title: 'Ano mais recente',
        description:
          'Primeiro botão. Vazio = ano corrente. O ano em que a lista abre vai na consulta do bloco (Título contém o ano).',
        type: 'number',
      },
      anoMaisAntigo: {
        title: 'Ano mais antigo',
        type: 'number',
      },
    },
  };
};

// A lista de filtros ativos do Volto pede um componente por tipo (a Lista DS
// esconde essa lista, mas ela é montada).
export const AnoTituloFilterListEntry = ({ facet, facets }) => (
  <span className="ui small label">{rotulo(String(facets[facet]))}</span>
);

AnoTituloFilterListEntry.propTypes = {
  facet: PropTypes.string.isRequired,
  facets: PropTypes.object.isRequired,
};

export default AnoTituloFacet;
